/*
 * ADA accessibility shim for the Identixweb sliding cart (ISSUE-25).
 * The cart drawer is injected client-side by the Identixweb app as bare <div>s
 * with no roles/names/keyboard support, so it can't be fixed in theme markup.
 * This observes the DOM and patches the app's controls after each render:
 *   - drawer        -> role=dialog + aria-modal + label; inert + aria-hidden when closed (ISSUE-17)
 *   - +/- quantity  -> role=button + tabindex + label + Enter/Space activation
 *   - remove / close -> role=button + tabindex + label + keyboard
 *   - qty value & free-shipping bar -> aria-live status regions
 *   - discount code input -> aria-label (ISSUE-11)
 *   - cart item images with empty alt -> alt from item title (ISSUE-28)
 * No functional/visual change; only ARIA + keyboard affordances are added.
 */
(function(){
  function lbl(el,t){ if(el && !el.getAttribute('aria-label')) el.setAttribute('aria-label',t); }
  function asButton(el,label){
    if(!el) return;
    if(!el.getAttribute('role')) el.setAttribute('role','button');
    if(el.getAttribute('tabindex')===null) el.setAttribute('tabindex','0');
    lbl(el,label);
    if(!el.__adaKey){ el.__adaKey=true;
      el.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '||e.key==='Spacebar'){ e.preventDefault(); el.click(); } });
    }
  }
  function patch(){
    var drawer=document.querySelector('.ia-sliding-cart');
    if(drawer){
      if(!drawer.getAttribute('role')) drawer.setAttribute('role','dialog');
      drawer.setAttribute('aria-modal','true'); lbl(drawer,'Shopping cart');
      // ISSUE-17: when the drawer is closed it stays in the DOM (slid off-screen)
      // with focusable children. Make it inert + hidden from AT until opened.
      var open = drawer.classList.contains('ia-sliding-cart--active');
      if(open === drawer.hasAttribute('inert')){ // state mismatch -> sync (idempotent, avoids observer loop)
        drawer.toggleAttribute('inert', !open);
        if(open) drawer.removeAttribute('aria-hidden'); else drawer.setAttribute('aria-hidden','true');
      }
    }
    document.querySelectorAll('.ia-quantity-iterator-button').forEach(function(btn){
      var t=(btn.textContent||'').trim();
      asButton(btn, t==='+'?'Increase quantity':((t==='-'||t==='−')?'Decrease quantity':'Change quantity'));
    });
    document.querySelectorAll('.quantity-iterator__value').forEach(function(v){ lbl(v,'Quantity'); if(!v.getAttribute('role')) v.setAttribute('role','status'); if(!v.getAttribute('aria-live')) v.setAttribute('aria-live','polite'); });
    document.querySelectorAll('.ia-close-icon').forEach(function(x){ asButton(x, x.closest('.ia-cart-item-container, .ia-cart-list-item') ? 'Remove item' : 'Close cart'); });
    document.querySelectorAll('.ia-title-bar-buttons-group > span').forEach(function(x){ asButton(x,'Close cart'); });
    document.querySelectorAll('.ia-offers-back-button').forEach(function(x){ asButton(x,'Back'); });
    document.querySelectorAll('.ia-rewards-banner').forEach(function(r){ if(!r.getAttribute('role')) r.setAttribute('role','status'); if(!r.getAttribute('aria-live')) r.setAttribute('aria-live','polite'); });
    // ISSUE-11: discount code input has only a placeholder -> give it an accessible name.
    document.querySelectorAll('.ia-offers-bottom-sheet-text-input, .ia-sliding-cart input[type="text"]').forEach(function(inp){
      lbl(inp, inp.getAttribute('placeholder') || 'Discount code');
    });
    // ISSUE-28: cart item image with empty alt -> derive from the item title.
    document.querySelectorAll('.ia-cart-item-image').forEach(function(img){
      if(img.tagName!=='IMG') return;
      var a=(img.getAttribute('alt')||'').replace(/\s*-\s*null\s*$/i,'').trim();
      if(!a){
        var item=img.closest('.ia-cart-item-container, .ia-cart-list-item, .ia-cart-item-ultimate-parent-container');
        var titleEl=item && item.querySelector('.ia-cart-item-title');
        a=titleEl?titleEl.textContent.trim():'Product image';
      }
      img.setAttribute('alt', a);
    });
  }
  function boot(){ patch(); var mo=new MutationObserver(function(){ clearTimeout(window.__adaT); window.__adaT=setTimeout(patch,150); }); mo.observe(document.body,{childList:true,subtree:true}); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();
